module.exports = __webpack_public_path__ + "static/media/nz.7dab6e5e.svg";